import { useMemo } from "react";
import Loading from "_shared/components/Loading/Loading";
import LineChart from "_shared/components/TradingView/LineChart";
import { useChartDataQuery } from "_shared/graphql";
import styles from "../Chart.module.scss";
import { massageData } from "../utilities";

interface Props {
  ticker: string;
}

const formatDate = (date: Date) => date.toLocaleDateString("fr-CA");

function ImpliedVolatility({ ticker }: Props) {
  const threeMonthsAgo = new Date(Date.now() - 90 * 24 * 60 * 60 * 1000);
  const variables = {
    ticker,
    from: formatDate(threeMonthsAgo),
    to: formatDate(new Date()),
    interval: "daily",
    fields: ["put_imp_vol_30d", "timestamp"],
  };
  const { data, loading } = useChartDataQuery({ variables });

  const chartData = useMemo(
    () =>
      data?.get_charting_data?.data
        ? massageData(data.get_charting_data.data, "put_imp_vol_30d")
        : null,
    [data],
  );

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Implied volatility</h3>
      <div className={styles.graphContainer}>
        {chartData ? (
          <LineChart
            data={chartData}
            curvedLines
            formatValue={(val) => `${Math.floor(val * 100)}%`}
            priceLine={{ price: 0, color: "#777" }}
            ticker={ticker}
          />
        ) : (
          <div className={styles.graphState}>
            {loading ? <Loading variant="inner" /> : "Error loading data"}
          </div>
        )}
      </div>
    </div>
  );
}

export default ImpliedVolatility;
